import moment from "moment";
import KonsultasiDokter from "../assets/category-icons/icon-chat-doctor.png";

export const IGNORE_TYPE =
  "Ml mL ml ML Kg KG kg Gram gram GRAM Liter LITER L Mg MG mg g G mcg Mcg MCG Unit";

export const dates = [
  {
    value: 1,
    name: "Semua Data",
  },
  {
    value: 2,
    name: "Hari ini",
  },
  {
    value: 3,
    name: "Kemarin",
  },
  {
    value: 4,
    name: "Minggu Berjalan",
  },
  {
    value: 5,
    name: "Minggu Lalu",
  },
  {
    value: 6,
    name: "Bulan Berjalan",
  },
  {
    value: 7,
    name: "Bulan Lalu",
  },
  {
    value: 8,
    name: "Tahun Berjalan",
  },
  {
    value: 9,
    name: "Tahun Lalu",
  },
];

export const week = [
  {
    value: 0,
    day: "Minggu",
  },
  {
    value: 1,
    day: "Senin",
  },
  {
    value: 2,
    day: "Selasa",
  },
  {
    value: 3,
    day: "Rabu",
  },
  {
    value: 4,
    day: "Kamis",
  },
  {
    value: 5,
    day: "Jumat",
  },
  {
    value: 6,
    day: "Sabtu",
  },
];

export const statusTransaction = {
  processed: "#FF8D40",
  cancelledOrComplained: "#F21B3F",
  done: "#00CD52",
  waitingPayment: "#9AA4B2",
};

export const inventoryStatus = {
  1: "Create Product",
  2: "Update Product",
  3: "Stock Opname In",
  4: "Stock Opname Out",
  5: "Stock Adjustment In",
  6: "Stock Adjustment Out",
  7: "Delete Product",
  8: "POS Transaction",
  9: "Generate Invoice",
  10: "Retur Product",
};

export const sortOptions = [
  {
    value: 1,
    name: "Produk Terbaru",
  },
  {
    value: 2,
    name: "Terakhir diubah",
  },
  {
    value: 3,
    name: "Harga Tertinggi",
  },
  {
    value: 4,
    name: "Harga Terendah",
  },
  {
    value: 5,
    name: "Nama Produk A-Z",
  },
  {
    value: 6,
    name: "Nama Produk Z-A",
  },
  {
    value: 7,
    name: "Stock Terbanyak",
  },
  {
    value: 8,
    name: "Stock Terendah",
  },
];

export const productTypeOptions = [
  {
    id: 1,
    name: "Produk Aktif",
  },

  {
    id: 2,
    name: "Produk Tidak Aktif",
  },

  {
    id: 3,
    name: "Produk Habis",
  },

  {
    id: 4,
    name: "Produk ditahan",
  },

  {
    id: 5,
    name: "Produk Expired",
  },
];

export const transactionDetailStatus = {
  1: "Pending",
  2: "Success",
  3: "Reject",
};

export const transactionDetailStatusColor = {
  1: "#ffae00",
  2: "#23ff00",
  3: "#ff2d00",
};

export const statusMapped = {
  1: "Semua",
  2: "Berlangsung",
  3: "Selesai",
  4: "Dibatalkan",
  5: "Menunggu Konfirmasi",
  6: "Diproses",
  7: "Dikirim",
  8: "Tiba ditujuan",
  9: "Dikomplain",
  10: "Menunggu Pembayaran",
  11: "Siap Diambil",
};

export const statusMappedInvoice = {
  1: "Semua",
  2: "Lunas",
  3: "Lunas",
  4: "Dibatalkan",
  5: "Lunas",
  6: "Lunas",
  7: "Lunas",
  8: "Lunas",
  9: "Dibatalkan",
  10: "Lunas",
  11: "Siap Diambil",
};

export const yearFormatBilling = (date) => moment(date).format("YYYY");

export const WHITELIST_DOMAIN = ["olin-psef", "psef"];

export const HEALTH_INFORMATION = [
  {
    title: "Minum air putih yang cukup",
    content:
      "Tubuh membutuhkan air putih setidaknya 8 gelas atau ±2 liter per hari untuk menjaga fungsi organ dan mencegah dehidrasi.",
    icon: KonsultasiDokter,
  },
  {
    title: "Tidur yang cukup dan berkualitas",
    content:
      "Usahakan tidur 7–8 jam setiap malam agar tubuh dan otak dapat beristirahat serta memperbaiki sel yang rusak.",
    icon: KonsultasiDokter,
  },
  {
    title: "Konsumsi buah dan sayur setiap hari",
    content:
      "Buah dan sayur kaya vitamin, mineral, dan serat yang membantu menjaga daya tahan tubuh dan pencernaan.",
    icon: KonsultasiDokter,
  },
  {
    title: "Rutin berolahraga ringan",
    content:
      "Lakukan aktivitas fisik minimal 30 menit per hari seperti jalan kaki atau stretching untuk menjaga kebugaran tubuh.",
    icon: KonsultasiDokter,
  },
  {
    title: "Kurangi makanan tinggi gula dan lemak",
    content:
      "Konsumsi gula dan lemak berlebih dapat meningkatkan risiko obesitas dan penyakit kronis.",
    icon: KonsultasiDokter,
  },
  {
    title: "Cuci tangan secara rutin",
    content:
      "Mencuci tangan dengan sabun sebelum makan dan setelah beraktivitas membantu mencegah penyebaran kuman dan penyakit.",
    icon: KonsultasiDokter,
  },
  {
    title: "Kelola stres dengan baik",
    content:
      "Luangkan waktu untuk relaksasi, bernafas dalam, atau melakukan hobi agar kesehatan mental tetap terjaga.",
    icon: KonsultasiDokter,
  },
];
